// src/solana/weareSusuPdas.ts
import { PublicKey } from "@solana/web3.js";

/**
 * Must match on-chain seeds in lib.rs:
 * V1: POOL_SEED="pool", VAULT_SEED="vault", MEMBER_SEED="member"
 * V2: POOL_V2_SEED="pool_v2", VAULT_V2_SEED="vault_v2", MEMBER_V2_SEED="member_v2"
 */

export const POOL_SEED_V1 = Buffer.from("pool");
export const VAULT_SEED_V1 = Buffer.from("vault");
export const MEMBER_SEED_V1 = Buffer.from("member");

export const POOL_SEED_V2 = Buffer.from("pool_v2");
export const VAULT_SEED_V2 = Buffer.from("vault_v2");
export const MEMBER_SEED_V2 = Buffer.from("member_v2");

// ===== V1
export function derivePoolPdaV1(programId: PublicKey, authority: PublicKey): [PublicKey, number] {
  return PublicKey.findProgramAddressSync([POOL_SEED_V1, authority.toBuffer()], programId);
}

export function deriveVaultPdaV1(programId: PublicKey, pool: PublicKey): [PublicKey, number] {
  return PublicKey.findProgramAddressSync([VAULT_SEED_V1, pool.toBuffer()], programId);
}

export function deriveMemberPdaV1(
  programId: PublicKey,
  pool: PublicKey,
  wallet: PublicKey
): [PublicKey, number] {
  return PublicKey.findProgramAddressSync(
    [MEMBER_SEED_V1, pool.toBuffer(), wallet.toBuffer()],
    programId
  );
}

// ===== V2
export function derivePoolPdaV2(programId: PublicKey, authority: PublicKey): [PublicKey, number] {
  return PublicKey.findProgramAddressSync([POOL_SEED_V2, authority.toBuffer()], programId);
}

export function deriveVaultPdaV2(programId: PublicKey, poolV2: PublicKey): [PublicKey, number] {
  return PublicKey.findProgramAddressSync([VAULT_SEED_V2, poolV2.toBuffer()], programId);
}

export function deriveMemberPdaV2(
  programId: PublicKey,
  poolV2: PublicKey,
  wallet: PublicKey
): [PublicKey, number] {
  return PublicKey.findProgramAddressSync(
    [MEMBER_SEED_V2, poolV2.toBuffer(), wallet.toBuffer()],
    programId
  );
}
